import { Text } from "@ecco/ui/text";
import { Box } from "@ecco/ui/box";
import type { ReactNode } from "react";
import { SummarySectionHeadline } from "./SummarySectionHeadline";

type SummarySectionProps = {
    headline?: string | ReactNode;
    content?: string[] | ReactNode;
};

export const SummarySection = ({ headline, content }: SummarySectionProps) => {
    const renderContent = () => {
        if (Array.isArray(content)) {
            return content.map((item, index) => (
                <Text
                    fontSize={[
                        "mobileBodyTextSmall",
                        "mobileBodyTextSmall",
                        "desktopBodyTextSmall",
                    ]}
                    key={index}
                >
                    {item}
                </Text>
            ));
        }
        return <>{content}</>;
    };

    const renderHeadline = () => {
        if (typeof headline === "string") {
            return <SummarySectionHeadline>{headline}</SummarySectionHeadline>;
        }
        return headline;
    };
    return (
        <Box>
            {renderHeadline()}
            <Box>{renderContent()}</Box>
        </Box>
    );
};
